import { CREATE_LEAD_URL, SUBMIT_QDE_URL, PAN_DEDUPE_URL, PAN_NAME_MISMATCH_URL, SUBMIT_EXISTING_CUST, orgId, VALIDATE_QDE_OTP_URL, GENERATE_OTP_URL_ENCRYPT, VALIDATE_OTP_URL_ENCRYPT, VALIDATE_QDE_OTP_URL_ENCRYPT, CREATE_LEAD_URL_ENCRYPT, SUBMIT_QDE_URL_ENCRYPT, SUBMIT_EXISTING_CUST_ENCRYPT, PAN_NAME_MISMATCH_URL_ENCRYPT, PAN_DEDUPE_URL_ENCRYPT, UPSELL_DOWNSEll_OFFER_ENCRYPT, FETCH_MASTER_URL_ENCRYPT, VALIDATE_QDE_OTP_URL_DECRYPT, VALIDATE_OTP_URL_DECRYPT } from './../config/app-settings.config';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GENERATE_OTP_URL, VALIDATE_OTP_URL, FETCH_MASTER_URL,UPSELL_DOWNSEll_OFFER } from '../config/app-settings.config';
import { EncrDecrService } from './encr-decr-service.service';

@Injectable()
export class QdeService {

  actualPromoCode: any;
  natureOfCompany: any;
  designationFlag: any;
  executionId: any;
  masterData: any;
  headers: any;
  aboutData: any;
  professionalData: any;
  qdeSubmitData: any;
  // qdeSubmitData = {
  //   leadRefNo: 25043010011,
  //   applicationNumber: 2504313010010,
  //   bestCardTypes: ["MMSU", "AIPU", "VPTL", "IRCP"],
  //   ckycStatus: "CKYC NOT INITIATED",
  //   statusCode: "12",
  //   statusDesc: "Soft Decision - Referred",
  //   upSell: "E",
  // }

  successMessageOTP: any;
  errorMessageOTP: any;
  tokenVal = window['authenticationDetails']['EapplyTokenGenerationResponse']['tokenGenerationResponse']['access_token'] || sessionStorage.getItem('jwt');
  s24AccessToken = sessionStorage.getItem("s24_access_token");
  s24TokenExpiryTime = sessionStorage.getItem("s24_expiry_time");
  path = window.location.origin + window.location.pathname;
  officeStdCode: any;
  officeCity: any;
  secondSectionData: any;
  existingUser: boolean;
  signedValueResponse: any;
  officeState: any;
  qdeOtpCount = false;
  existingOtpCounter: number;
  qdeOtpCounter: number;
  counterValidate = 0;
  existingJCounterValidate = 0;
  constructor(private http: HttpClient, private encryptDecService: EncrDecrService) {
  }

  generateOtp(creditcardnum, mobileNum, resendRequest, otpReasonCode) {
    let requestBody = {
      // creditCardNumber: '000' + mobileNum + '999999',
      creditCardNumber: creditcardnum,
      mobileNumber: mobileNum,
      // emailId: emailId,
      reasonCode: otpReasonCode,
      resendRequest: resendRequest,
      orgId: orgId,
      regenerationFlag: 'true'
    }

    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: 'Bearer ' + this.tokenVal,
        withCredentials: 'true',
        'Content-Type': 'application/json'
      })
    };
    requestBody = GENERATE_OTP_URL_ENCRYPT ? this.encryptDecService.set(requestBody) : requestBody;
    return this.http.post(`${GENERATE_OTP_URL}`, requestBody, httpOptions);
  }

  validateOtp(requestBody, fromQDE) {
    // const httpOptions = {
    //   headers: new HttpHeaders({
    //     Authorization: 'Bearer ' + this.tokenVal,
    //     withCredentials: 'true',
    //     'Content-Type': 'application/json'
    //   })
    // };

    
    if (fromQDE) {
      let httpOptions:any;
      if(VALIDATE_QDE_OTP_URL_DECRYPT){
        httpOptions = {
          headers: new HttpHeaders({
            Authorization: "Bearer " + this.tokenVal,
            withCredentials: "true",
            "Content-Type": "application/json"
          }),
          responseType:'text'
        };
      } else{
        httpOptions = {
          headers: new HttpHeaders({
            Authorization: "Bearer " + this.tokenVal,
            withCredentials: "true",
            "Content-Type": "application/json"
          }),
        };
      }
      requestBody = VALIDATE_QDE_OTP_URL_ENCRYPT ? this.encryptDecService.set(requestBody) : requestBody;
      return this.http.post(`${VALIDATE_QDE_OTP_URL}`, requestBody, httpOptions);
    } else {
      let httpOptions:any;
      if(VALIDATE_OTP_URL_DECRYPT){
        httpOptions = {
          headers: new HttpHeaders({
            Authorization: "Bearer " + this.tokenVal,
            withCredentials: "true",
            "Content-Type": "application/json"
          }),
          responseType:'text'
        };
      } else{
        httpOptions = {
          headers: new HttpHeaders({
            Authorization: "Bearer " + this.tokenVal,
            withCredentials: "true",
            "Content-Type": "application/json"
          }),
        };
      }
      requestBody = VALIDATE_OTP_URL_ENCRYPT ? this.encryptDecService.set(requestBody) : requestBody;
      return this.http.post(`${VALIDATE_OTP_URL}`, requestBody, httpOptions);
    }

  }

  fetchMatserData(requestBody) {
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: 'Bearer ' + this.tokenVal,
        withCredentials: 'true',
        'Content-Type': 'application/json',
      })
    };

    requestBody = FETCH_MASTER_URL_ENCRYPT ? this.encryptDecService.set(requestBody) : requestBody;
    return this.http.post(`${FETCH_MASTER_URL}`, requestBody, httpOptions);
  }


  createUpdateLead(requestBody) {
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: 'Bearer ' + this.tokenVal,
        withCredentials: 'true',
        'Content-Type': 'application/json',
        "signedValue": this.signedValueResponse,
      })
    };
    console.log('create update req', requestBody);
    
    requestBody = CREATE_LEAD_URL_ENCRYPT ? this.encryptDecService.set(requestBody) : requestBody;
    console.log("encryoted request create update lead", requestBody);
    console.log("header for createUpdateLead", httpOptions);
    return this.http.post(`${CREATE_LEAD_URL}`, requestBody, httpOptions);
    // return this.http.get('/assets/mocks/fetchMasterData.json');

  }

  panDedupecheck(panNumber) {
    let httpOptions: any;
    
    if (this.s24AccessToken && this.s24TokenExpiryTime) {
      httpOptions = {
        headers: new HttpHeaders({
          Authorization: "Bearer " + this.tokenVal,
          withCredentials: "true",
          "Content-Type": "application/json",
          "access_token": this.s24AccessToken,
          "expiry_time": this.s24TokenExpiryTime
        }),
        observe: 'response'
      };
    } else {
      httpOptions = {
        headers: new HttpHeaders({
          Authorization: "Bearer " + this.tokenVal,
          withCredentials: "true",
          "Content-Type": "application/json"
        }),
        observe: 'response'
      };
    }

    panNumber = PAN_DEDUPE_URL_ENCRYPT ? this.encryptDecService.set(panNumber) : panNumber;
    return this.http.post(`${PAN_DEDUPE_URL}`, panNumber, httpOptions);
  }

  panMismatch(requestBody) {
    let httpOptions: any;
    
    if (this.s24AccessToken && this.s24TokenExpiryTime) {
      httpOptions = {
        headers: new HttpHeaders({
          Authorization: "Bearer " + this.tokenVal,
          withCredentials: "true",
          "Content-Type": "application/json",
          "access_token": this.s24AccessToken,
          "expiry_time": this.s24TokenExpiryTime,
        }),
        observe: 'response'
      };
    } else {
      httpOptions = {
        headers: new HttpHeaders({
          Authorization: "Bearer " + this.tokenVal,
          withCredentials: "true",
          "Content-Type": "application/json",
        }),
        observe: 'response'
      };
    }

    requestBody = PAN_NAME_MISMATCH_URL_ENCRYPT ? this.encryptDecService.set(requestBody) : requestBody;
    return this.http.post(`${PAN_NAME_MISMATCH_URL}`, requestBody, httpOptions);
  }

  qdeSubmit(requestBody) {
    let httpOptions: any;
    
    if (this.s24AccessToken && this.s24TokenExpiryTime) {
      httpOptions = {
        headers: new HttpHeaders({
          Authorization: "Bearer " + this.tokenVal,
          withCredentials: "true",
          "Content-Type": "application/json",
          "access_token": this.s24AccessToken,
          "expiry_time": this.s24TokenExpiryTime,
          "signedValue": this.signedValueResponse,
        }),
        observe: 'response'
      };
    } else {
      httpOptions = {
        headers: new HttpHeaders({
          Authorization: "Bearer " + this.tokenVal,
          withCredentials: "true",
          "Content-Type": "application/json",
          "signedValue": this.signedValueResponse
        }),
        observe: 'response'
      };
    }
    console.log('qde REquest', requestBody);
    
    requestBody = SUBMIT_QDE_URL_ENCRYPT ? this.encryptDecService.set(requestBody) : requestBody;
    return this.http.post(`${SUBMIT_QDE_URL}`, requestBody, httpOptions);
    // return this.http.post('http://172.18.252.32:8899/services/resource/createQDE/qde-submit', requestBody, httpOptions);
  }

  cardUpsellDownsellFromOffer(requestBody) {
    let httpOptions: any;
    if (this.s24AccessToken && this.s24TokenExpiryTime) {
      httpOptions = {
        headers: new HttpHeaders({
          Authorization: "Bearer " + this.tokenVal,
          withCredentials: "true",
          "Content-Type": "application/json",
          "access_token": this.s24AccessToken,
          "expiry_time": this.s24TokenExpiryTime
        }),
        observe: 'response'
      };
    } else {
      httpOptions = {
        headers: new HttpHeaders({
          Authorization: "Bearer " + this.tokenVal,
          withCredentials: "true",
          "Content-Type": "application/json"
        }),
        observe: 'response'
      };
    }
    requestBody = UPSELL_DOWNSEll_OFFER_ENCRYPT ? this.encryptDecService.set(requestBody) : requestBody;
    return this.http.post(`${UPSELL_DOWNSEll_OFFER}`, requestBody, httpOptions);
  }
  existingUserSubmit(requestBody) {
    let httpOptions: any;
    if (this.s24AccessToken && this.s24TokenExpiryTime) {
      httpOptions = {
        headers: new HttpHeaders({
          Authorization: "Bearer " + this.tokenVal,
          withCredentials: "true",
          "Content-Type": "application/json",
          "access_token": this.s24AccessToken,
          "expiry_time": this.s24TokenExpiryTime
        })
      };
    } else {
      httpOptions = {
        headers: new HttpHeaders({
          Authorization: "Bearer " + this.tokenVal,
          withCredentials: "true",
          "Content-Type": "application/json"
        })
      };
    }
    requestBody = SUBMIT_EXISTING_CUST_ENCRYPT ? this.encryptDecService.set(requestBody) : requestBody;
    return this.http.post(`${SUBMIT_EXISTING_CUST}`, requestBody, httpOptions);
  }

}
